export default __webpack_public_path__ + "images/leri-ship.svg";